import React from "react";
import { NakiStoreHomeSectionTemplate } from "themes/administration/naki-store/components";
import { NakiStoreHomeSectionViewStore } from "administration/naki-store/stores";
import { setCurrentView } from "mrb/core";

@setCurrentView(
    (rootStore, componentProps) => new NakiStoreHomeSectionViewStore(rootStore, componentProps),
    "nakiStoreHomeSectionViewStore"
)
class NakiStoreHomeSection extends React.Component {
    render() {
        return <NakiStoreHomeSectionTemplate {...this.props} />;
    }
}

export default NakiStoreHomeSection;
